<template>
	<article class="faq-question" :id="faq.id">
		<h3 class="question" v-html="faq.question"></h3>
		<p class="answer" v-html="faq.answer"></p>
	</article>
</template>

<script>
export default {
	props: ['faq']
}
</script>

<style scoped>

</style>